import { FC, ReactNode, MouseEvent } from 'react'
import { DrawerContainer, Drawer, CloseButtonContainer, DrawerContent, DrawerHeader } from './styles'
import { MdOutlineKeyboardArrowRight } from 'react-icons/md'

interface RightDrawerProps {
  children?: ReactNode;
  open: boolean;
  toggle: () => void;
  header?: ReactNode;
  hidden?: boolean;
}

const RightDrawer: FC<RightDrawerProps> = ({ children, open, toggle, header, hidden }) => {
  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    toggle()
  }

  return (
    <DrawerContainer open={open} onClick={handleClick} hidden={hidden}>
      <Drawer onClick={e => e.stopPropagation()} open={open}>
        <CloseButtonContainer onClick={handleClick} open={open}>
          <MdOutlineKeyboardArrowRight />
        </CloseButtonContainer>
        {header ? (
          <DrawerHeader>
            {header}
          </DrawerHeader>
        ) : null}
        <DrawerContent>
          {children}
        </DrawerContent>
      </Drawer>
    </DrawerContainer>
  )
}

export default RightDrawer